export enum TagEnum {
    GREEN,
    RED,
}
